import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

export const Wave: React.FC = () => <StyledCol>~</StyledCol>;
interface TdProps {
  verticalAlign?: string;
  colSpan?: number;
}
export const CustomTd: React.FC<TdProps> = ({
  verticalAlign = "top",
  children,
  colSpan,
}) => (
  <StyledTd colSpan={colSpan} verticalAlign={verticalAlign}>
    <StyledCellWrapper>{children}</StyledCellWrapper>
  </StyledTd>
);

export const StyledTd = styled.td<TdProps>`
  padding: 8px 16px;
  vertical-align: ${({ verticalAlign }) => verticalAlign};
  column-span: ${({ colSpan }) => colSpan || 1};
`;
export const StyledCol = styled(Col)`
  line-height: 32px;
`;

export const StyledCellWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  position: relative;
`;
export const StyledRow = styled(Row)`
  flex: 0 0 432px;
  height: 32px;
`;
export const StyledColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;
export const StyledModalContainer = styled.div`
  padding: 24px;
`;
export const StyledSubTitle = styled.span`
  color: ${theme.colors.gray6};
  ${theme.typo.body.r12};
  line-height: 12px;
`;
export const StyledTitleWrapper = styled.span`
  line-height: 24px;
`;
export const StyledTemporaryRestWrapper = styled.div`
  background: #f3f5fa;
  border-radius: 8px;
  padding: 20px;
`;
export const StyledInputTitle = styled.div`
  justify-content: flex-start;
  display: flex;
  height: 32px;
  color: ${theme.colors.gray1};
  flex-wrap: nowrap;
  ${theme.typo.heading.b14};
  line-height: 24px;
  align-items: flex-start;
`;
export const StyledDateRangePicker = styled.div`
  width: 400px;
`;
export const MaximumLabelWrapper = styled.div`
  ${theme.typo.heading.b14};
  line-height: 32px;
`;
